import { Stack, useTheme, useMediaQuery } from '@mui/material';
import { useBannerStore } from '@/stores/bannerStore';
import NotesHeader from '@/pages/MyNotes/components/NotesHeader/NotesHeader';
import SavedNotesContent from './components/SavedNotesContent';

const SavedNotes = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { headerHeight } = useBannerStore();

  return (
    <Stack alignItems="center" pt={4} pb={0} px={isMobile ? 2 : 4} height={`calc(100vh - ${headerHeight}px)`}>
      <NotesHeader title="Watched Notes" description="Shared notes you've watched and saved." />
      <SavedNotesContent />
    </Stack>
  );
};

export default SavedNotes;
